import React, { Component } from "react";

import Flickity from "flickity";
import cx from "classnames";
import get from "lodash/get";
import contentfulImgUtil from "utils/contentfulImgUtil";

import { Image } from "components/base";

import { Media } from "types";

interface Props {
  activeImageIndex?: number;
  getActiveImageIndex(index: number): void;
  images?: Media[];
  imageClassName: string;
  className: string;
  children?: React.ReactNode;
  pageDots: boolean;
  altFallback: string;
  imageSize?: string;
}

const defaultProps = {
  className: "",
  imageClassName: "",
  getActiveImageIndex: () => {},
  pageDots: true,
  altFallback: ""
};

class ImageCarousel extends Component<Props> {
  static defaultProps = defaultProps;

  wrapper: null | Element = null;
  flickity: null | Flickity = null;

  componentDidMount() {
    this.initializeCarousel();
  }

  initializeCarousel() {
    if (this.wrapper) {
      this.flickity = new Flickity(this.wrapper, {
        initialIndex: 0,
        wrapAround: true,
        draggable: true,
        freeScroll: false,
        prevNextButtons: false,
        accessibility: true,
        pageDots: this.props.pageDots,
        on: {
          ready: () => {
            setTimeout(() => this.flickity && this.flickity.resize(), 0);
          }
        }
      });
    }
  }

  render() {
    const {
      images,
      children,
      imageClassName,
      className,
      altFallback,
      imageSize
    } = this.props;

    return (
      <div
        className={cx("ImageCarousel", className)}
        ref={node => (this.wrapper = node)}
      >
        {images &&
          !children &&
          images.map((image: Media, i: number) => (
            <Image
              key={image.title}
              className={cx("wh100", imageClassName)}
              src={
                imageSize ? contentfulImgUtil(image.url, imageSize) : image.url
              }
              alt={get(image, "description", `${altFallback} ${i + 1}`)}
            />
          ))}
        {children && !images && children}
      </div>
    );
  }
}

export default ImageCarousel;
